var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};
import { newGuid } from "../GuidHelper.js";
function logPltAndPerfTiming(timepoint, logger, now, additionalPltProperties = {}) {
  logger.trackMetric({
    name: `PLT:${timepoint}`,
    average: now,
    properties: __spreadValues({
      url: document.location.href
    }, additionalPltProperties)
  });
  performance.mark && performance.mark(timepoint);
  let perfTiming;
  try {
    perfTiming = !performance.getEntries ? "performance.getEntries not defined" : JSON.parse(JSON.stringify(performance.getEntries()));
  } catch (e) {
    perfTiming = "failed to get perftimings";
  }
  if (Array.isArray(perfTiming)) {
    perfTiming.forEach((item, index) => {
      logger.trackMetric({
        name: `PerfTiming:${timepoint}`,
        average: now,
        // @ts-ignore
        sampleCount: null,
        // @ts-ignore
        min: null,
        // @ts-ignore
        max: null,
        properties: __spreadValues({
          url: document.location.href,
          totalTimings: perfTiming.length,
          timingIndex: index
        }, item)
      });
    });
  } else {
    logger.trackMetric({
      name: `PerfTiming:${timepoint}`,
      average: now,
      // @ts-ignore
      sampleCount: null,
      // @ts-ignore
      min: null,
      // @ts-ignore
      max: null,
      properties: {
        url: document.location.href,
        perfTimingFailulre: perfTiming
      }
    });
  }
  performance.clearResourceTimings && performance.clearResourceTimings();
}
const getErrorPayload = (error = "An Error occured", properties) => {
  const id = newGuid();
  let payload = null;
  if (typeof error === "string") {
    payload = {
      id,
      message: error,
      properties
    };
  } else {
    const _a = error || {}, { name, message, stack, notificationHandled } = _a, rest = __objRest(_a, ["name", "message", "stack", "notificationHandled"]);
    let useProperties = __spreadValues(__spreadValues({
      stack,
      notificationHandled
    }, rest), properties);
    if (notificationHandled) {
      useProperties = __spreadProps(__spreadValues({}, useProperties), { suppressPopup: true });
    }
    payload = {
      error,
      id,
      properties: useProperties
    };
  }
  return payload;
};
export {
  getErrorPayload,
  logPltAndPerfTiming
};
//# sourceMappingURL=Logger.utils.js.map
